module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '5cpnat5l',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
